import { $, isMobile } from '@utils';
import lottie from 'lottie-web';

function init() {
  formHeaderLottieAnimation();

  isMobile.addEventListener('change', () => {
    formHeaderstickyContent();
  });

  formHeaderstickyContent();
}

function formHeaderLottieAnimation() {
  if (!$('[data-au-form-header-lottie]')) return;
  const lottieContainer = $('[data-au-form-header-lottie]');
  const lottiePath = $('[data-au-form-header-lottie]').dataset.auFormHeaderLottie;

  lottie.loadAnimation({
    container: lottieContainer,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: lottiePath,
  });
}

function formHeaderstickyContent() {
  const formHeaderContent = $('[data-au-form-header-content-sticky]');
  if (!formHeaderContent) return;

  if (!isMobile.matches) {
    formHeaderContent.style.position = 'sticky';
    const header = $('header');

    if (header) {
      const images = header.querySelectorAll('img');
      const headerHeight = `${header.getBoundingClientRect().height}px`;

      if (images.length) {
        const imagesLoaded = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        });
        Promise.all(imagesLoaded).then(() => {
          formHeaderContent.style.top = headerHeight;
        });
      } else {
        formHeaderContent.style.top = headerHeight;
      }
    } else {
      formHeaderContent.style.top = '0px';
    }
  } else {
    formHeaderContent.style.position = 'relative';
  }
}

export default { init };
